import { useState, useEffect } from 'react'

const Timer = () => {
  const [elapsedTime, setElapsedTime] = useState(0)

  useEffect(() => {
    const startTime = Date.now()

    const interval = setInterval(() => {
      const currentTime = Date.now()
      const timeElapsed = Math.floor((currentTime - startTime) / 1000)
      setElapsedTime(timeElapsed)
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  }

  return (
    <div>
      <h2 className="">Time Elapsed</h2>
      <p className="text-neutral-500 text-[24px]">{formatTime(elapsedTime)}</p>
    </div>
  )
}

export default Timer